
import { Component, Vue, Prop } from "vue-property-decorator";
import { ISigmaRing } from '@/interfaces/mlm';
import { IPackage, IInvoice } from "@/interfaces/mlm";
import {
  dispatchGetOrCreateInvoice,
  dispatchGetPackages,
  dispatchGetPaymentStatus,
  dispatchGetUserSigmaRings,
  dispatchProcessConfirmInvoice, dispAuthFetch,
} from "@/store/mlm/actions";
import { readActivePackage, readInvoiceResponse } from "@/store/mlm/getters";
import { dispatchGetUserProfile, dispatchGetUsdtDexnetRate } from "@/store/main/actions";
import { readUserProfile } from "@/store/main/getters";
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import PurchaseAgreementModal from "./PurchaseAgreementModal.vue";
import RingsPurchaseModal from "./RingsPurchaseModal.vue";
@Component({
  components: {
    PurchaseAgreementModal,
    RingsPurchaseModal,
  }
})

export default class ProductPurchase extends Vue {
  @Prop({ type: Object, required: false, default: null }) readonly product!: ISigmaRing | null;
  
  public showProductPaymentRingsModal = false

  public isConfirmAgreement: boolean = false;

  public countryList = [
  {value: 'CA', label: 'Canada'},
  {value: 'GB', label: 'United Kingdom'},
  {value: 'DE', label: 'Germany'},
  {value: 'FR', label: 'France'},
  {value: 'IT', label: 'Italy'},
  {value: 'ES', label: 'Spain'},
  {value: 'AT', label: 'Austria'},
  {value: 'SK', label: 'Slovakia'},
  {value: 'SI', label: 'Slovenia'},
  {value: 'RO', label: 'Romania'},
  {value: 'BG', label: 'Bulgaria'},
  {value: 'PL', label: 'Poland'},
  {value: 'CH', label: 'Switzerland'},
  {value: 'SE', label: 'Sweden'},
  {value: 'DK', label: 'Denmark'},
  {value: 'FI', label: 'Finland'},
  {value: 'NL', label: 'Netherlands'},
  {value: 'LU', label: 'Luxembourg'},
  {value: 'BE', label: 'Belgium'},
  {value: 'CZ', label: 'Czech Republic'},
  {value: 'GR', label: 'Greece'},
  {value: 'LT', label: 'Lithuania'},
  {value: 'EE', label: 'Estonia'},
  {value: 'LV', label: 'Latvia'},
  {value: 'IE', label: 'Ireland'},
  {value: 'PT', label: 'Portugal'},
  {value: 'NO', label: 'Norway'},
  {value: 'RU', label: 'Russian Federation'},
  {value: 'BY', label: 'Belarus'},
  {value: 'KZ', label: 'Kazakhstan'},
  {value: 'UA', label: 'Ukraine'},
  {value: 'AE', label: 'UAE (Dubai)'}
  ];

  public countryCodeList = ['CA',
   'GB',
   'DE',
   'FR',
   'IT',
   'ES',
   'AT',
   'SK',
   'SI',
   'RO',
   'BG',
   'PL',
   'CH',
   'SE',
   'DK',
   'FI',
   'NL',
   'LU',
   'BE',
   'CZ',
   'GR',
   'LT',
   'EE',
   'LV',
   'IE',
   'PT',
   'NO',
   'RU',
   'BY',
   'KZ',
   'UA',
   'AE',
  ];


  public formData = {
    name: '',
    surname: '',
    email: '',
    telegram: '',
    phone: '',
    country: '',
    city: '',
    street: '',
    house: '',
    apartment: '',
    postalCode: ''
  };


  public loadingState: any = {
    standart: false,
    submit: false,
  };
  
  public standart: string = "";
  public invoiceDetail: IInvoice | null = null;
  public transaction: any = null;
  public progressPercent = 100;
  public timeToReload = 15;
  public invoiceId = null
  public errorMessage = ""
  public purchaseRequest = null

  // --- modal
  public showAgreementModal: boolean = false;
  public showRingsPurchaseModal: boolean = false;
  // --- methods

  public async onSubmit() {
    // Защита от повторных нажатий
    if (this.loadingState.submit) {
      return;
    }

    // Проверяем валидность формы с помощью vee-validate
    const isValid = await this.$validator.validateAll();
    
    if (isValid) {
      // Обработка отправки формы
      // console.log('Form data:', this.formData);
      // Здесь можно добавить логику отправки данных на сервер
      this.handleProcessPayment();
    } else {
      console.error('Form validation failed');
    }
  }

  public handleClose() {
   // console.log('handleClose');
    this.$emit('close-purchase');
  }

  // Phone validation methods
  public formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove any non-digit characters except + at the start
    value = value.replace(/[^\d+]/g, '');
    
    // If user starts typing without +, add it
    if (!value.startsWith('+') && value.length > 0) {
      value = '+' + value;
    }
    
    // Try to auto-format based on available countries
    for (const country of this.countryCodeList) {
      try {
        const phoneNumber = parsePhoneNumber(value, country as any);
        if (phoneNumber && phoneNumber.isPossible()) {
          this.formData.phone = phoneNumber.formatInternational();
          return;
        }
      } catch (e) {
        // Continue trying other countries
      }
    }
    
    // If no match found, just update with the cleaned value
    this.formData.phone = value;
  }

  public validatePhoneNumber(phone: string, countryCode?: string): boolean {
    if (!phone) return false;
    
    // Try all supported countries if no specific country is selected
    if (!countryCode) {
      for (const country of this.countryCodeList) {
        if (isValidPhoneNumber(phone, country as any)) {
          return true;
        }
      }
      return false;
    }
    
    return isValidPhoneNumber(phone, countryCode as any);
  }

  // --- check
  public async updateProgressBar() {

    this.progressPercent = this.progressPercent - 6.66;
    this.timeToReload = this.timeToReload - 1;
    if (this.progressPercent > 0) {
      setTimeout(() => this.updateProgressBar(), 1000);
    } else {
      await dispatchGetUserProfile(this.$store);
      this.progressPercent = 100;
      this.timeToReload = 15;
      await this.updatePaymentInfo();
      this.updateProgressBar();
    }
  }

  
  // --- summ to deposit if not enough
  public needSomeMoney() {
    
    const balance = this.userProfile
        ? Number(this.userProfile.balances.units_total)
        : 0;
 
    const r = Math.abs(balance - Number(this.product?.price))
    return Math.round(r);
    
  }
  
  public async updatePaymentInfo() {
    if (this.invoiceResponse && this.invoiceDetail) {
      const paymentResponse = await dispatchGetPaymentStatus(this.$store, {
        address: this.invoiceResponse.address,
        invoice: this.invoiceDetail.id,
      });
      if (paymentResponse) {
        this.invoiceDetail = paymentResponse.invoice;
        // this.transaction = paymentResponse.transaction;
      }
      // this.progressPercent = 100;
      // this.timeToReload = 15;
      // this.updateProgressBar();
    }
  }

  // --- purchase methods
  public async requestInvoice(token: string) {
    // console.log('requestInvoice',this.product, this.product?.id);

   
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/sigma_ring/purchase/request/",
      init: {
        method: "POST",
        body: {
          sigma_ring: this.product?.id,
          standart: "BEP20",
          token: token
        },
      }
    });
    // console.log('invoiceResp', invoiceResp);

    if (invoiceResp && invoiceResp.status === 200) {
      //  this.invoiceId = (await invoiceResp.json()).invoice.id
      const invoiceData = (await invoiceResp.json()).invoice
      this.invoiceId = invoiceData.id
    } else if (invoiceResp && invoiceResp.status === 400) {
      this.$toast.error("Error");
    }
  }

  public async handleProcessPayment() {
   
   this.loadingState.submit = true
   this.errorMessage = ""

   if (this.invoiceId) {
    
       const invoiceResp = await dispAuthFetch(this.$store, {
         input: "/api/v1/mlm/sigma_ring/purchase/confirm/",
         init: {
           method: "POST",
           body: {
             invoice: this.invoiceId,
             // email: this?.userProfile?.email
             first_name: this.formData.name,
             last_name: this.formData.surname,
             email: this.formData.email,
             telegram: this.formData.telegram,
             phone: this.formData.phone,
             country: this.formData.country,
             city: this.formData.city,
             street: this.formData.street,
             house: this.formData.house,
             apartment: this.formData.apartment,
             postal_code: this.formData.postalCode
           },
         },
       });

       if (invoiceResp && invoiceResp.status === 200) {
         this.purchaseRequest = await invoiceResp.json()
         this.$toast.success(this.$t('Successfully purchased').toString())
         // add show RingsPurchaseModal
         this.showRingsPurchaseModal = true;
         await dispatchGetUserSigmaRings(this.$store);
        // this.$emit('update-rings');
         // Не закрываем родительский компонент сразу, чтобы модальное окно успешной покупки осталось видимым
         // Родительский компонент закроется после того, как пользователь закроет RingsPurchaseModal
       } else if (invoiceResp && invoiceResp.status === 400) {
         const error = await invoiceResp.json()
         if(error.email)
           this.errorMessage = this.$t("Invalid email").toString()
         if(error.detail)
           this.errorMessage = this.$t('This package is temporarily unavailable').toString()
         if(error.invoice)
           this.errorMessage = this.$t('Insufficient funds').toString()
         this.$toast.error(this.$t("ERROR").toString() + ": " + this.errorMessage);
       }

       this.loadingState.submit = false
   }
 }

 // --- show modal agreement
 public handleShowAgreementModal(){
  this.showAgreementModal = true
 }

 public handleCloseAgreementModal(){
  this.showAgreementModal = false
 }

 public handleCloseRingsPurchaseModal(){
  this.showRingsPurchaseModal = false
  // Закрываем родительский компонент после закрытия модального окна успешной покупки
  this.handleClose()
 }

  // --- getters
  get invoiceResponse() {
    return readInvoiceResponse(this.$store);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get parsedProductName() {
    if (!this.product?.name) return '';
    
    const name = this.product.name;
    
    // Check if it's "Size Kit - Over size" format
    if (name.includes('Size Kit - ')) {
      return name.replace('Size Kit - ', '');
    }
    
    // Check if it contains " - Size: " pattern
    if (name.includes(' - Size: ')) {
      return name.split(' - Size: ')[0];
    }
    
    // Return original name if no pattern matches
    return name;
  }

  get parsedProductSize() {
    if (!this.product?.name) return '';
    
    const name = this.product.name;
    
    // Don't show size for "Size Kit" products
    if (name.includes('Size Kit - ')) {
      return '';
    }
    
    // Extract size from " - Size: X" pattern
    if (name.includes(' - Size: ')) {
      const sizeMatch = name.match(/ - Size: (\d+)/);
      return sizeMatch ? sizeMatch[1] : '';
    }
    
    // Return empty string if no pattern matches
    return '';
  }

  /* 1 запрашиваем инвойс
    2 оплачиваем 
  */
  public async mounted() {
    // Register custom phone validator
    this.$validator.extend('validatePhone', {
      getMessage: () => 'Некорректный номер телефона',
      validate: (value: string) => {
        // Get the selected country from form data
        const selectedCountry = this.formData.country;
        
        // If country is selected, validate for that specific country
        if (selectedCountry) {
          return this.validatePhoneNumber(value, selectedCountry);
        }
        
        // Otherwise, try to validate for any supported country
        return this.validatePhoneNumber(value);
      }
    });

    // by default USDT request Invoice on mounted and get amount if DexNet for priceDexnet
    await this.requestInvoice("USDT");
  }
}
